import type { DateTime } from 'luxon';
import { memo } from 'react';

interface CellDateProps {
  date?: DateTime;
}

const CellDate = memo(({ date }: CellDateProps) => (
  <span className="mr-1 inline bg-brand/10 px-1 py-1 font-mono">{date?.toFormat('MM/dd')}</span>
));

export default CellDate;
